import { render, staticRenderFns } from "./FileEditOld.vue?vue&type=template&id=6e70c4f1&scoped=true"
import script from "./FileEditOld.vue?vue&type=script&lang=js"
export * from "./FileEditOld.vue?vue&type=script&lang=js"
import style0 from "./FileEditOld.vue?vue&type=style&index=0&id=6e70c4f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e70c4f1",
  null
  
)

export default component.exports